// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list-filters {
  display: flex;
}
.dl-iam-access-dialog-access-list-filters__search {
  flex: 1;
  margin-right: 8px;
}
.dl-iam-access-dialog-access-list-filters__subject-type {
  width: 170px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/Filters/Filters.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,OAAA;EACA,iBAAA;AACR;AAEI;EACI,YAAA;AAAR","sourcesContent":[".dl-iam-access-dialog-access-list-filters {\n  display: flex;\n}\n.dl-iam-access-dialog-access-list-filters__search {\n  flex: 1;\n  margin-right: 8px;\n}\n.dl-iam-access-dialog-access-list-filters__subject-type {\n  width: 170px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
